export const manifest = {
  screens: {
    scr_iwo41e: { name: "Home", route: "/" },
  },
}
